import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SlitValveSealRoutingModule } from './slit-valve-seal-routing.module';
import { SlitValveSealComponent } from './slit-valve-seal.component';
import { PageHeaderModule } from '../page-header/page-header.module';

@NgModule({
  declarations: [SlitValveSealComponent],
  imports: [
    CommonModule,
    SlitValveSealRoutingModule,
    PageHeaderModule
  ]
})
export class SlitValveSealModule { }
